import React from 'react';

const SIZE = 300;
const C = SIZE / 2;
const R = 105;

const frac = (v) => (v === null || v === undefined ? 0.04 : Math.max(0.04, Math.min(1, (v - 50) / 50)));

const pt = (i, n, f, r = R) => {
  const a = (-90 + (i * 360) / n) * (Math.PI / 180);
  return [C + r * f * Math.cos(a), C + r * f * Math.sin(a)];
};

export const RadarChart = ({ axes }) => {
  const n = axes.length;
  const poly = axes.map((a, i) => pt(i, n, frac(a.value)).join(',')).join(' ');
  return (
    <svg width={SIZE} height={SIZE} viewBox={`0 0 ${SIZE} ${SIZE}`} className="shrink-0 max-w-full" data-testid="radar-svg">
      {[0.2, 0.4, 0.6, 0.8, 1].map((f) => (
        <polygon key={f} points={axes.map((_, i) => pt(i, n, f).join(',')).join(' ')} fill="none" stroke="#27272a" strokeWidth="1" />
      ))}
      {axes.map((_, i) => { const [x, y] = pt(i, n, 1); return <line key={i} x1={C} y1={C} x2={x} y2={y} stroke="#27272a" strokeWidth="1" />; })}
      <polygon points={poly} fill="rgba(16,185,129,0.25)" stroke="#10b981" strokeWidth="2" className="transition-all duration-700" data-testid="radar-polygon" />
      {axes.map((a, i) => { const [x, y] = pt(i, n, frac(a.value)); return <circle key={i} cx={x} cy={y} r="3.5" fill={a.value === null ? '#52525b' : '#10b981'} />; })}
      {axes.map((a, i) => {
        const [x, y] = pt(i, n, 1, R + 22);
        const anchor = x < C - 10 ? 'end' : x > C + 10 ? 'start' : 'middle';
        return (
          <text key={a.key} x={x} y={y} textAnchor={anchor} fill="#a1a1aa" fontSize="9" fontWeight="800" style={{ textTransform: 'uppercase', letterSpacing: '0.08em' }}>
            <tspan x={x} dy="0">{a.label}</tspan>
            <tspan x={x} dy="11" fill="#fff">{a.value === null ? '—' : Math.round(a.value)}</tspan>
          </text>
        );
      })}
    </svg>
  );
};
